<template>
    <div class="tabs-container">
        <div class="tabs-row">
            <div class="tab-fixed" :class="{ 'tab-fixed-active': selectedIndex === 0 }" @click="goToListTab">
                <span>Parteneri</span>
            </div>
            <DxTabs
                v-if="partnerTabs.length > 0"
                class="tabs-scroll"
                :data-source="partnerTabs"
                :selected-index="selectedIndex - 1"
                item-template="tabItem"
                :scrolling-enabled="true"
                :show-nav-buttons="true"
                @option-changed="onTabChanged"
            >
                <template #tabItem="{ data, index }">
                    <div class="tab-label">
                        <span>{{ data.text }}</span>
                        <span class="tab-close" @click.stop="closeTab(index)">×</span>
                    </div>
                </template>
            </DxTabs>
        </div>

        <div v-show="selectedIndex === 0" class="tab-content">
            <GridTabParteneri @select-partener="onPartenerSelected" class="grid-fill" />
        </div>

        <template v-for="(p, i) in openPartners" :key="p.partenerId">
            <div v-if="selectedIndex === i + 1" class="tab-content">
                <GridParteneriDetalii :partener="p.partenerData" class="fill" @back="goToListTab" />
            </div>
        </template>
    </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { DxTabs } from 'devextreme-vue/tabs';
import CrmParteneri from '@/services/Comercial/CrmParteneri';
import GridTabParteneri from './GridTabParteneri.vue';
import GridParteneriDetalii from './GridParteneriDetalii.vue';
import partenerForm from '@/components/library/partener-form.vue';

interface OpenPartnerTab {
    partenerId: string;
    partenerData: Record<string, any>;
}

export default defineComponent({
    components: {
        DxTabs,
        GridTabParteneri,
        GridParteneriDetalii,
        partenerForm
    },
    data() {
        return {
            selectedIndex: 0,
            openPartners: [] as OpenPartnerTab[],
            partnerTabs: [] as { text: string, partenerId: string }[],
        };
    },
    mounted() {
        if (this.$route.query.partenerId) {
            const id = this.$route.query.partenerId as string;
            this.fetchPartener(id);
        }
    },
    watch: {
        '$route.query.partenerId': {
            handler(newId) {
                if (newId) {
                    this.fetchPartener(newId as string);
                }
            },
        }
    },
    methods: {
        onTabChanged(e: any) {
            if (e.name !== 'selectedIndex') return;
            const internalIndex = e.component.option('selectedIndex');
            if (internalIndex == null || internalIndex < 0) return;
            this.selectedIndex = internalIndex + 1;
        },
        goToListTab() {
            this.selectedIndex = 0;
        },
        onPartenerSelected(partener: any) {
            this.openPartener(partener);
        },
        openPartener(partener: any) {
            const id = String(partener.ID);
            const existingIndex = this.openPartners.findIndex(p => p.partenerId === id);
            if (existingIndex !== -1) {
                this.selectedIndex = existingIndex + 1;
                return;
            }
            this.openPartners.push({ partenerId: id, partenerData: partener });
            this.partnerTabs = [...this.partnerTabs, { text: partener.Nume || 'Partener', partenerId: id }];
            this.selectedIndex = this.partnerTabs.length;
        },
        closeTab(index: number) {
            const wasActiveTab = this.selectedIndex === index + 1;
            const activePartenerId = wasActiveTab ? null : this.openPartners[this.selectedIndex - 1]?.partenerId;

            this.openPartners.splice(index, 1);
            this.partnerTabs = this.partnerTabs.filter((_, i) => i !== index);

            if (wasActiveTab) {
                // Închizi partenerul pe care îl vizualizai — te întorci mereu pe gridul de parteneri
                this.selectedIndex = 0;
            } else {
                // Închizi un tab din fundal — rămâi pe partenerul curent, doar recalculezi indexul
                const newIndex = activePartenerId
                    ? this.openPartners.findIndex(p => p.partenerId === activePartenerId) + 1
                    : 0;
                this.selectedIndex = newIndex;
            }
        },
        fetchPartener(id: string) {
            if (!id || id === '') return;
            CrmParteneri.getById(id).then((response) => {
                this.openPartener(response.data);
            }).catch(error => {
                console.error("Error fetching partener:", error);
            });
        }
    }

});
</script>
<style scoped>
.tabs-container {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.tabs-row {
    display: flex;
    align-items: stretch;
    flex-shrink: 0;
}

.tab-fixed {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px 16px;
    cursor: pointer;
    white-space: nowrap;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.6);
    border-bottom: 2px solid transparent;
    transition: color 0.15s, border-color 0.15s;
}

.tab-fixed:hover {
    color: rgba(0, 0, 0, 0.87);
}

.tab-fixed-active {
    color: #ff2c21;
    border-bottom-color: #ff2c21;
    font-weight: 600;
}

.tabs-scroll {
    flex: 1;
    min-width: 0;
}

.tab-content {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
}

.grid-fill {
    flex: 1;
    min-height: 0;
}

.fill {
    flex: 1;
    min-height: 0;
    width: 100%;
}

.tab-label {
    display: flex;
    align-items: center;
    gap: 6px;
}

.tab-close {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    font-size: 14px;
    line-height: 1;
    color: #94a3b8;
    cursor: pointer;
    transition: background 0.15s, color 0.15s;
}

.tab-close:hover {
    background: #fee2e2;
    color: #ef4444;
}
</style>
